import React, {Component} from 'react';
import {gpn} from "../GPN"
import req from "../req";
import config from "../config";
import ModalLoading from "../sections/ModalLoading";

class About extends Component {

    state = {
        about: "",

        loading: true
    };

    componentDidMount() {
        this.props.setTitle("درباره ما");
        req.getRequest(`${config.api}/user/about`)
            .then(r => {
                this.setState({
                    about: r.about,
                    loading: false
                });
            })
            .catch(err => {
                this.setState({
                    loading: false
                });
            });
    }


    render() {
        let {about, loading} = this.state;
        return (
            <div className="about">
                <ModalLoading loading={loading}/>
                <pre>{about}</pre>
            </div>
        );
    }
}

export default gpn(About);